"use strict";
window.addEventListener("hashchange", function() {
    if (window.location.hash === "#menu") document.body.classList.add("page__body--no-scrol");
    else document.body.classList.remove("page__body--no-scrol");
});
var form = document.getElementById("form");
var text = document.getElementById("text");
var mail = document.getElementById("mail");
var textarea = document.getElementById("textarea");
form.addEventListener("submit", function(event) {
    event.preventDefault();
    text.value = "";
    mail.value = "";
    textarea.value = "";
});

//# sourceMappingURL=index.49b7b8e1.js.map
